import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import "./Embed.css";

const Embed = React.memo(({ value = "", classes = [] }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.innerHTML = ""; // Clear existing content

      // Create a temporary container to parse HTML
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = value;

      // Append non-script elements
      Array.from(tempDiv.childNodes).forEach((node) => {
        if (node.tagName !== "SCRIPT") {
          containerRef.current.appendChild(node.cloneNode(true));
        }
      });

      // Execute <script> tags manually
      const scriptTags = tempDiv.querySelectorAll("script");
      scriptTags.forEach((oldScript) => {
        const newScript = document.createElement("script");
        // Copy attributes
        Array.from(oldScript.attributes).forEach(attr =>
          newScript.setAttribute(attr.name, attr.value)
        );
        newScript.textContent = oldScript.textContent; // for inline scripts
        document.body.appendChild(newScript);
      });
    }
  }, [value]);

  return <div className={["Embed", ...classes].join(" ")} ref={containerRef} />;
});

Embed.propTypes = {
  value: PropTypes.string,
  post_id: PropTypes.string,
  componenentKey: PropTypes.number,
};

Embed.displayName = "Embed";

export default Embed;
